import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  slideNumber: number;
  lang: string;
}

function DeleteConfirmationDialog({ open, onClose, onConfirm, slideNumber, lang }: DeleteConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        {lang === 'en' ? 'Delete Slide' : '删除幻灯片'}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {lang === 'en' 
            ? `Are you sure you want to delete slide ${slideNumber}?` 
            : `确定要删除第 ${slideNumber} 张幻灯片吗？`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {lang === 'en' ? 'Cancel' : '取消'}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {lang === 'en' ? 'Delete' : '删除'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationDialog; 